/* eslint-disable */
// import styles from './ProductDescription.module.scss'
import useTranslation from 'next-translate/useTranslation'

import RichTextTrimmer from '@/molecules/RichTextTrimmer'

function ProductDescription({ value, embedded, tags }: DescriptionProps) {
  const { t } = useTranslation('products')
  const embeddedSource = embedded
    ?.replace(
      /.*youtu\.be\/([\w-]+)(\?.*)?/,
      'https://www.youtube.com/embed/$1'
    )
    ?.replace(
      /.*youtube\.com\/watch\?v=([\w-]+)(\&.*)?/,
      'https://www.youtube.com/embed/$1'
    )
    ?.replace(
      /.*youtube\.com\/shorts\/([\w-]+)(\?.*)?/,
      'https://www.youtube.com/embed/$1'
    )

  return (
    <>
      <div className="mt-6 2sm:mt-12 2md:mt-16">
        <h2 className="mb-3 text-xl font-medium md:text-2xl">
          {t('description')}
        </h2>
        <RichTextTrimmer value={value} />
        <div className="flex flex-wrap gap-1 mt-4">
          {tags?.split(',').map((tag) => (
            <Tag key={tag} tag={tag} />
          ))}
        </div>
      </div>
      {embedded && (
        <div className="mt-12">
          <h2 className="mb-3 text-xl font-medium md:text-2xl">
            {t('product_embedded_video')}
          </h2>
          <div className="pt-[56.25%] relative rounded-lg overflow-hidden">
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src={embeddedSource}
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </>
  )
}

const Tag = ({ tag }: { tag: string }) => {
  return (
    <span className="px-4 py-1 mr-2 text-sm font-medium rounded-lg bg-sbtviolet-200">
      {tag}
    </span>
  )
}

interface DescriptionProps {
  tags: string
  value: string
  embedded: string | undefined
}

export default ProductDescription
